import api from "./api";

const measurementFieldConfigService = {
  async getAll(params = {}) {
    try {
      const response = await api.get("/measurement-field-configs", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getGarmentCategories() {
    try {
      const response = await api.get("/measurement-field-configs/garment-categories");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/measurement-field-configs/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async create(data) {
    try {
      const response = await api.post("/measurement-field-configs", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, data) {
    try {
      const response = await api.put(`/measurement-field-configs/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await api.delete(`/measurement-field-configs/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete an entire garment category — removes field configs AND customer measurements
  async deleteCategory(garmentCategory) {
    try {
      const response = await api.delete(`/measurement-field-configs/category/${encodeURIComponent(garmentCategory)}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Replaces all fields for a garment category in one shot
  async bulkCreate(data) {
    try {
      const response = await api.post("/measurement-field-configs/bulk", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default measurementFieldConfigService;
